import CompanyQuoteDisclosure from './CompanyQuoteDisclosure'
// Uncomment the below to migrate to stateful component
// import CompanyQuoteDisclosureContainer from './CompanyQuoteDisclosureContainer'

export { CompanyQuoteDisclosure }
export default CompanyQuoteDisclosure
// Uncomment the below to migrate to stateful component
// export { CompanyQuoteDisclosureContainer }
// export default { CompanyQuoteDisclosureContainer }
